import { GlobalToken } from 'antd/es/theme/interface';
import { Grid, theme } from 'antd';
import { responsiveArray } from 'antd/es/_util/responsiveObserver';
import { useMemo } from 'react';

export const useResponsiveGlobalTokenValue = <K extends keyof GlobalToken>(
  baseTokenKey: K
): GlobalToken[K] => {
  const screens = Grid.useBreakpoint();
  const { token } = theme.useToken();

  return useMemo(
    () =>
      responsiveArray.reduce<any>((value, breakpoint) => {
        if (value) {
          return value;
        }
        const tokenKey = `${baseTokenKey}${
          breakpoint.toUpperCase() as Uppercase<typeof breakpoint>
        }` as const;
        return screens[breakpoint] && tokenKey in token
          ? token[tokenKey as keyof GlobalToken]
          : null;
      }, null) || token[baseTokenKey],
    [screens, token, baseTokenKey]
  );
};
